let storeKey = 'stCompany';

let savedState = window.localStorage.getItem(storeKey) || '{}';
savedState = JSON.parse(savedState);


const state = Object.assign({}, {
   user: {
      id: null,
      name: null,
      screenName: null,
      avatar: null,
      donts: null,
      allowedCompanies: 0,
      idiom: 'pt',
      allowedStatus: null,
      workingCo: null,
      notifications: [],
      changePin: false
   },
   brandCode: null,
   brand: {
      id: null,
      name: null,
      logo: null,
      facebook: null,
      instagram: null
   },
   isPartner: 0,
   multiStore: false,
   brandStores: [],
   selectedStore: 0,
   selectedStoreName: '',

   lookups: null,

   settings: null
}, savedState);

// console.log(state);


const mutations = {
   stRegisterCompany (state, data) {
      //NEVER UPDATE AS AN OBJECT!!!

      //User
      state.user.id = data.id;
      state.user.name = data.name;
      state.user.screenName = data.screenName;
      state.user.donts = data.donts;
      state.user.allowedCompanies = data.allowedCompanies;
      state.user.idiom = data.idiom;
      state.user.avatar = data.avatar;
      state.user.workingCo = data.companyId;
      state.user.notifications = data.notifications || [];
      state.user.changePin = +data.changePin;

      state.user.allowedStatus = data.allowedStatus;

      state.isPartner = data.partner;
      if (data.partner) {
         let donts = {
            routes: ['/partners']
         };
         if (!state.user.donts) {
            state.user.donts = donts;
         } else {
            if (state.user.donts.routes) {
               state.user.donts.routes.push('/partners');
            } else {
               state.user.donts.routes = ['/partners'];
            }
         }

         console.log('Partner Donts: ', state.user.donts);

      }

      //Settings
      if (data.settings) {
         state.settings = null;
         state.settings = data.settings;
      }

      //Brand
      state.brand.id = data.brand.id;
      state.brand.name = data.brand.name;
      state.brand.logo = data.brand.logo;
      state.brand.facebook = data.brand.facebook;
      state.brand.instagram = data.brand.instagram;

      if (window.cloudinaryOptions) {
         Object.keys(window.cloudinaryOptions).forEach(k => {
            console.log(window.cloudinaryOptions[k]);
            window.cloudinaryOptions[k].context.brandId = data.brand.id;
         });
      }

      //Lookups
      if (data.lookups) {
         state.lookups = null;
         state.lookups = data.lookups;
      }


      //BrandStores
      if (data.brandStores) {
         state.brandStores = data.brandStores;
         state.multiStore = data.multiStore;
         state.selectedStore = data.selectedStore;
         state.selectedStoreName = data.selectedStoreName;
      } else {
         state.selectedStore = -1;
         state.selectedStoreName = 'No Brand Store on server';
      }

      window.sessionToken = data.authToken;
      window.localStorage.setItem('stAuthToken', data.authToken);
      window.localStorage.setItem('stDonts', JSON.stringify(state.user.donts));
      window.localStorage.setItem(storeKey, JSON.stringify(state));

      if (data.idiom) {
         window.getApp.$i18n.locale = data.idiom;
      }
      // console.log('TOKEN:', station.authToken);

   },

   stSelectCompany (state, data) {
      state.selectedStore = data.id;
      state.selectedStoreName = data.name;
   },

   stSetBrandCode (state, value) {
      state.brandCode = value;
      window.localStorage.setItem(storeKey, JSON.stringify(state));
   },

   stSetPinChanged (state) {
      state.user.changePin = 0;
      window.localStorage.setItem(storeKey, JSON.stringify(state));
   }

};

const actions = {
   stRegisterCompany: async ({ commit }, data) => {
      data.screenName = data.name.split(' ')[0];
      commit('stRegisterCompany', data);
      setTimeout(() => {
         window.getApp.$emit('APP_LOGIN_SUCCESS');
      }, 200); //timer for animation happens after setting init to false;

   },
   stSelectCompany: ({ commit }, data) => {
      commit('stSelectCompany', data);
      window.getApp.$emit('SELECTED_STORE_CHANGED', data);
   },
   stSaveBrandCode: ({ commit }, data) => {
      commit('stSetBrandCode', data);
   },
   stSetPinChanged: ({ commit }) => {
      commit('stSetPinChanged');
   }
};

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js